// Quick Compare document script.
//
// This is PDF-side JavaScript: it runs inside Acrobat, not in the browser.
// It used to live as a resource inside the pdf-generator jar; it lives here
// now so it can be changed without rebuilding and redeploying the generator.
//
// The `{...}` tokens below are NOT JavaScript template placeholders. The
// generator substitutes {quickCompareMapData}, {s3Key}, {referrer},
// {pdfType} and {locale} server-side before attaching the script to the
// document, because those values are only known there. String.raw keeps the
// text byte-for-byte as written -- no escape processing, no interpolation.

const scripts = String.raw`
try {
  // object keys compressed to save some bytes
  //{
  //  competitor: '**', // competitor superscript
  //  productsMap: {
  //    "Epson T7270 Post Script MFP": {
  //      // "id"
  //      i: 1,
  //      // "superscript", e.g. for competitors
  //      s: true,
  //      // "features"
  //      f: [
  //        "$18043",
  //        "Yes",
  //        "110 mL (Black)\n110 mL (Color)",
  //        "25 seconds"
  //      ]
  //    }
  //  }
  //}
  var quickCompareMapData = {quickCompareMapData};
  // Quick Compare - Valid Comparison Values
  var qc_vcv = false;
  var k_b_vc = 'qc_view-comparison';
  var k_b_ec = 'qc_email-comparison-button';
  var k_f_ec = 'qc_email-comparison';
  var qc_btn_viewComparison = gF(k_b_vc);
  var qc_btn_emailComparison = gF(k_b_ec);
  var qc_text_emailComparison = gF(k_f_ec);
  var qc_buttons_exist = !!qc_btn_viewComparison || !!qc_btn_emailComparison;
  var qc_first_btn = (qc_buttons_exist && (qc_btn_viewComparison || qc_btn_emailComparison) || {});
  // REOPEN: page 0 is a real page -- "|| -1" treated it as missing, so a
  // quick-compare section on the first page never found its saved overlays
  // again and every save/reopen cycle stacked a fresh set on top.
  var qc_page = typeof qc_first_btn.page == 'number' && qc_first_btn.page >= 0 ? qc_first_btn.page : -1;
  var locale = "{locale}";

  var qcAnnots = [];
  var qc_features_enabled = false;
  function qc_toggleLandingFeatures(hidden) {
    qcAnnots.forEach(function(annot) {
      setAnnotVisibility(annot, !hidden);
    });

    if (qc_text_emailComparison) {
      var visibility = hidden ? display.hidden : display.visible;

      qc_text_emailComparison.readonly = hidden;
      qc_text_emailComparison.display = visibility;

      qc_btn_viewComparison.display = visibility;
      qc_btn_emailComparison.display = visibility;
    }

    qc_features_enabled = !hidden;
  }

  function createQCAnnot(element) {
    var annot = createVisibilityAnnot_disabled(element.page, element, element.name);
    annot.lock = false;
    annot.opacity = 1;

    // Make rectangle slightly larger, to overlap borders at a scale
    var rect = annot.rect;
    annot.rect = [
      // Upper-left x, upper-left y,  lower-right x and lower-right y
      rect[0] - 2,
      rect[1] - 2,
      rect[2] + 2,
      rect[3] + 2,
    ];

    annot.lock = true;
    return annot;
  }

  // REOPEN: adopt only this script's own overlays -- the page can carry
  // user comments and (when quick-compare shares the find-by-features page)
  // the product visibility helpers; adopting those would toggle a user's
  // sticky note or fight the find-by-features logic.
  var pfx_annot_qc = pfx_annot_visibility + 'qc_';
  function qc_loadAnnots() {
    // Acrobat loads saved annotations lazily; force the scan so a reopened
    // document's saved overlays are actually found instead of re-created
    // on top (same mechanism as in the base script's
    // setupToggleableAnnotations)
    if (typeof this.syncAnnotScan == 'function') this.syncAnnotScan();
    var existingAnnots = this.getAnnots({ nPage: qc_page });
    if (!existingAnnots) return;
    existingAnnots.forEach(function(existingAnnot) {
      if (typeof existingAnnot.name == 'string' && existingAnnot.name.indexOf(pfx_annot_qc) > -1)
        qcAnnots.push(existingAnnot);
    });
  }
  var qc_init_id = -1;
  function qc_initAnnots() {
    if (qc_buttons_exist) {
      qc_loadAnnots();

      // Create visibility anotations
      if (qcAnnots.length === 0) {
        var targets = [qc_btn_viewComparison, qc_text_emailComparison, qc_btn_emailComparison];
        targets.forEach(function(target) {
          if (target) {
            var annot = createQCAnnot(target);
            qcAnnots.push(annot);
          }
        });

        qc_toggleLandingFeatures(!qc_features_enabled);
      }

      app.clearInterval(qc_init_id);
    }
  }

  const fontSize = 10;
  const fontSize_sm = 8;
  const fontSize_sm_min = 40;
  function qc_setColumnData(product, name, column_id) {
    var title_field = getField("qc_title_" + column_id);
    title_field.value = (product ? (name || '') : '') + (product && product.s ? quickCompareMapData.competitor : '');
    var feature_field = null;
    for (var field_ctr = 0; feature_field = getField("qc_feature_" + column_id + "_" + field_ctr); ++field_ctr) {
      feature_field.value = product ? product.f[field_ctr] || '' : '';

      if (feature_field.valueAsString.length <= fontSize_sm_min) {
        feature_field.textSize = fontSize;
      } else {
        feature_field.textSize = fontSize_sm;
      }
    }
  }
  //
  //"qc_select_X
  //"qc_title_X"
  //"qc_feature_X_X"
  var qc_cache = {};
  function qc_fieldEdited(field_name, column_id) {
    var field = getField(field_name);
    var field_value = (field.value || '').trim();
    if (field_value === qc_cache[field_name]) return;
    qc_cache[field_name] = field_value;
    var product = quickCompareMapData && quickCompareMapData.productsMap[field_value];
    qc_setColumnData(product, field_value, column_id);

    qc_toggleLandingFeatures(!qc_validateProductSelection())
  }

  function qc_getSelectedProductNames() {
    var keys = Object.keys(qc_cache);

    return keys.reduce(function(acc, key) {
      var value = qc_cache[key];
      var product = quickCompareMapData.productsMap[value];
      // Remove duplicates
      if (acc.indexOf(value) === -1 && product)
        return [...acc, value];
      return acc;
    }, []);
  }

  function qc_getProductIds(productNames) {
    return productNames.reduce(function(acc, productName) {
      var product = quickCompareMapData.productsMap[productName];
      if (product)
        return [...acc, product.i];
      return acc;
    }, []);
  }

  function qc_validateProductSelection() {
    var keys = Object.keys(qc_cache);

    // First column must be a primary brand product
    if (!quickCompareMapData.productsMap[qc_cache[keys[0]]])
      return false;

    var values = qc_getSelectedProductNames();

    // Must have at least 2 columns
    if (values.length < 2)
      return false;

    return true;
  }

  function qc_applyListener(field_name, column_id) {
    var field = gF(field_name);
    if (!field) return;
    field.setAction('Calculate', 'qc_fieldEdited(\"' + field_name + '\", ' + column_id + ')');
    field.commitOnSelChange = true;
  }

  function set_field_config(field) {
    field.alignment = 'center';
    field.readonly = true;
  }

  function set_initial_config(field_name, column_id) {
    var title_field = getField("qc_title_" + column_id);
    set_field_config(title_field);
    var feature_field = null;
    for (var field_ctr = 0; feature_field = getField("qc_feature_" + column_id + "_" + field_ctr); ++field_ctr) {
      set_field_config(feature_field);
    }
  }

  function qc_viewComparisonClicked() {
    var comparison_url = getComparisonUrl();

    if (comparison_url === null) {
      return;
    }

    app.launchURL({
      cURL: comparison_url
    });
  }

  function getComparisonUrl() {
    if (!qc_validateProductSelection())
      return null;

    var selected_product_names = qc_getSelectedProductNames();
    var comparison_product_ids = qc_getProductIds(selected_product_names);

    var ids_str = comparison_product_ids.join('/');
    return "{referrer}/{pdfType}/landing/{s3Key}/" + ids_str + "?lang={locale}";
  }

  function qc_emailComparisonClicked() {
    var email_field = gF('qc_email-comparison') || {};

    var comparison_url = getComparisonUrl();

    if (comparison_url === null) {
      return;
    }

    // A blank or missing field still has to yield a usable mailto, so fall
    // back to an empty address rather than "undefined".
    var email_address = String(email_field.value || '').trim();

    var url_params = {
      email: email_address,
      subject: 'Comparison%20Tool',
      body: getComparisonUrl()
    };

    var url = 'mailto:{email}?subject={subject}&body={body}';
    url = Object.keys(url_params).reduce(function (acc, key) {
      return acc.replace('{' + key + '}', url_params[key]);
    }, url);

    // Hand the prefilled message to the user's mail client. submitForm() used
    // to be called here, which posts the PDF's form DATA to the mail handler
    // instead of opening a message: a security prompt, a junk attachment, or
    // silence, depending on the reader.
    app.launchURL(url, true);
  }

  function qc_init() {
    var column_id = 0;
    while (true) {
      // Find all dropdown controllers
      var field_name = 'qc_select_' + column_id;
      var controller_dropdown = getField(field_name);
      if (!controller_dropdown) break;

      // REOPEN: prime the cache with the dropdown's CURRENT committed value
      // (the header label on a fresh export, the user's saved selection on
      // a reopened one). The old code read ".value" off the field NAME
      // string -- always undefined -- so the first Calculate pass after any
      // open rewrote all four comparison columns against half-initialized
      // state (49 field writes: the "first pick is the worst" outlier).
      qc_cache[field_name] = (controller_dropdown.value || '').trim();
      set_initial_config(field_name, column_id);
      qc_applyListener(field_name, column_id);

      ++column_id;
    }

    // REOPEN: derive the enabled flag from the (possibly saved) selections
    // instead of assuming the pristine no-selection baseline
    qc_features_enabled = qc_validateProductSelection();

    // AUDIT (2026-09-01): qc_buttons_exist is computed once at script load
    // and qc_initAnnots only clears the interval inside that same check, so
    // an export without the quick-compare buttons used to poll a no-op every
    // 500 ms for the life of the document. Don't start the poll at all.
    if (qc_buttons_exist)
      qc_init_id = app.setInterval('qc_initAnnots();', 500);
  }
  qc_init();
} catch(e) { app.alert(e) }
`;

export default scripts;
